export default __webpack_public_path__ + "static/media/1.d4dbdf89.jpg";